import WindowPortalHero from './components/WindowPortalHero';
import ManifestoSection from './components/ManifestoSection';
import SolutionsSection from './components/SolutionsSection';
import ProjectsSection from './components/ProjectsSection';
import LightComfortSection from './components/LightComfortSection';
import ProcessSection from './components/ProcessSection';
import WhyChooseSection from './components/WhyChooseSection';
import FaqSection from './components/FaqSection';
import EstimateSection from './components/EstimateSection';
import SiteFooter from './components/SiteFooter';
import useSmoothScroll from '@/hooks/useSmoothScroll';

export default function Home() {
  useSmoothScroll();
  return (
    <>
      <main className="bg-background-50">
        <WindowPortalHero />
        <ManifestoSection />
        <SolutionsSection />
        <ProjectsSection />
        <LightComfortSection />
        <ProcessSection />
        <WhyChooseSection />
        <FaqSection />
        <EstimateSection />
      </main>
      <SiteFooter />
    </>
  );
}